/**
 * Custom Timeline Template
 */

import { escapeHtml, createBlockWrapper } from '../utils';
import { applyThemeOverrides } from './utils';
import type { TemplateRenderer } from './types';

export const renderCustomTimeline: TemplateRenderer = (
  config,
  data,
  container,
  _onAction,
  themeOverrides
) => {
  const title = config.title as string | undefined;
  const showDates = (config.showDates as boolean) ?? true;
  const showStatus = (config.showStatus as boolean) ?? true;

  const items = (data.items || data.steps || []) as Array<{
    title: string;
    description?: string;
    date?: string;
    status?: 'complete' | 'current' | 'pending';
  }>;

  const wrapper = createBlockWrapper('custom-timeline');
  applyThemeOverrides(wrapper, themeOverrides);

  if (title) {
    const titleEl = document.createElement('div');
    titleEl.className = 'pms-custom-timeline-title';
    titleEl.textContent = title;
    wrapper.appendChild(titleEl);
  }

  const timeline = document.createElement('div');
  timeline.className = 'pms-custom-timeline';

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (!item) continue;

    const stepEl = document.createElement('div');
    stepEl.className = `pms-custom-timeline-item ${item.status ? `pms-timeline-${item.status}` : ''}`;

    let html = '<div class="pms-timeline-marker"></div>';
    html += '<div class="pms-timeline-content">';
    if (showDates && item.date) {
      html += `<div class="pms-timeline-date">${escapeHtml(item.date)}</div>`;
    }
    html += `<div class="pms-timeline-step-title">${escapeHtml(item.title)}</div>`;
    if (item.description) {
      html += `<div class="pms-timeline-description">${escapeHtml(item.description)}</div>`;
    }
    if (showStatus && item.status) {
      const statusLabel = item.status === 'complete' ? 'Complete' : item.status === 'current' ? 'In Progress' : 'Pending';
      html += `<div class="pms-timeline-status pms-timeline-status-${item.status}">${statusLabel}</div>`;
    }
    html += '</div>';

    stepEl.innerHTML = html;
    timeline.appendChild(stepEl);
  }

  wrapper.appendChild(timeline);
  container.appendChild(wrapper);
};
